
function MapController(){
	this.className	= "MapController";
	this.debug		= false;
	this.glob		= ["/","/static.html"];

	// var state = nav.getState();

	if(!this.venues){
		this.venues = this.getMeta().venues;
		this.google_maps_key = this.getMeta().google_maps_key;
	}

	this.setupMap();

	/*
	// Create the script tag, set the appropriate attributes
	var script = document.createElement('script');
	script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.google_maps_key + '&callback=initMap';
	script.async = true;
	script.defer = true;

	var infoWindow;

	// Attach your callback function to the `window` object
	window.initMap = () => {

		this.setupMap();
	};

	// Append the 'script' element to 'footer'
	document.body.appendChild(script);
	*/

	// this.mql             = window.matchMedia( '(max-width: 999px)' );
	// this.isMobile        = this.mql.matches;
	// console.log("isMobile",this.isMobile);

};
MapController.abstract = true;
MapController.inheritsFrom( StandardController );
MapController.prototype.off = function(){}

MapController.prototype.setupMap = function( ){
	// this.mql.onchange = () => this.onMediaChange();

	this.$gmap = $(".js-gmap");

	if (!this.$gmap) {
		return;
	}

	// this.getTemplates();
	var centre 	= this.savedPosition ? {lat: this.savedPosition.lat(), lng:this.savedPosition.lng()} : {lat: 51.55898394169364, lng:-0.221315436065197};
	var zoom	= this.savedZoom ? this.savedZoom : 10;

	// nav.addToLink($(".body").find("a[href^='/venue/']"));

	this.savedPageType = "map";
	this.enableClustering = false;

	if(!this.map){

		this.$filter = $(".venues-filter");

		this.mapWidthDelegate = Igloo.delegate(this,function(){

			if (!$('.filter-button-mobile').is(':visible')) {
				this.$gmap.width ( jstage.getWidth () - 340 ); //this.$filter.outerWidth()
			}else{
				this.$gmap.width ( jstage.getWidth ()  );
			}
			if ($('.filter-footer-mobile').is(':visible')) {
				//this.$gmap.height ( jstage.getHeight() - $('.filter-footer-mobile').outerHeight() );
				if(this.map) this.map.setOptions({zoomControl: false});
			}else{
				//this.$gmap.height ( jstage.getHeight() );
				if(this.map) this.map.setOptions({zoomControl: true});
			}
		});
		jstage.addListener("resize",this.mapWidthDelegate);
		this.mapWidthDelegate();


		var map = new google.maps.Map(this.$gmap.get(0), {
			center: centre,
			disableDefaultUI: true,
			zoomControl: !$('.filter-footer-mobile').is(':visible'),
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_BOTTOM
			},
			backgroundColor: 'none',
			zoom: zoom,
			maxZoom: 17,
			scrollwheel: false
		});
		this.map = map;
		//	backgroundPosition	string	The position of the cluster icon image within the image defined by url. The format is "xpos ypos" (the same format as for the CSS background-position venue). You must set this venue appropriately when the image defined by url represents a sprite containing multiple images. Note that the position must be specified in px units. The default value is "0 0".

		this.setMarkers(map);


		var styles = this.getStyles(zoom);
		map.setOptions({styles: styles});

		map.addListener("zoom_changed",Igloo.delegate(this,this.zoomChanged));
		map.addListener("center_changed",Igloo.delegate(this,this.positionChanged));
		map.addListener("click",Igloo.delegate(this,this.mapClick));

		this.fitBounds();


	}else{
		this.mapWidthDelegate();
		this.map.setCenter(centre);
		this.map.setZoom(zoom);
	}

	if(this.allowFitBounds){
		this.fitBounds();
	}
	this.allowFitBounds = false;


}
MapController.prototype.getStyles = function ( zoom ) {
	var styles = [
		{
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "administrative",
			"stylers": [
				{
					"color": "#bb8bb5"
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "landscape",
			"stylers": [
				{
					"color": "#291342"
				},
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"stylers": [
				{
					"color": "#173c4f"
				}
			]
		},
		{
			"featureType": "poi.park",
			"stylers": [
				{
					"color": "#4fabab"
				}
			]
		},
		{
			"featureType": "road",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#5b0944"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels",
			"stylers": [
				{
					"color": "#846c81"
				},
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#7f0b64"
				}
			]
		},
		{
			"featureType": "transit",
			"stylers": [
				{
					"color": "#3E5B6B"
				}
			]
		},
		{
			"featureType": "transit.station",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"stylers": [
				{
					"color": "#4fabab"
				},
				{
					"visibility": "on"
				}
			]
		}
	];
	return styles;
}
// Clear markers on filter
MapController.prototype.clearMarkers = function ( map) {
	var clearMarkers = Igloo.delegate(this, function() {

		if (this.infoBoxVenue) {
			this.infoBoxVenue.killBox();
			this.infoBoxVenue = null;
		}

		if (this.markerCluster) {
			this.markerCluster.clearMarkers ();
		}

		this.setMarkers(map);
	});

	if (this.infoBoxVenue) {
		this.infoBoxVenue.killBox();
		clearMarkers();
	} else {
		clearMarkers();
	}
};

// Replace the maps markers
MapController.prototype.setMarkers = function ( map) {
	var venues = this.venues;

	var infoBoxSetup = {
		disableAutoPan: true,
		maxWidth: 0,
		pixelOffset: new google.maps.Size(0, 0),
		zIndex: null,
		closeBoxURL: "",
		isHidden: false,
		pane: "floatPane",
		enableEventPropagation: false
	};

	var markers = [];
	for(var i in venues){
		var p = venues[i];
		p.index = i;

		if(p.location_lat*1 == 0 || p.location_long*1 == 0){
			Igloo.log("Could not find position for " + p.title);
			continue;
		}

		var marker = new google.maps.Marker({
			position: { lat: p.location_lat*1, lng: p.location_long*1 },
			map: map,
			icon: {
				url: '/assets/images/icons/map_marker.svg?r4',
				scale: 1,
				scaledSize: new google.maps.Size(32.4, 45.4),
			},
			title: p.business_name,
			website: p.website,
			//animation: google.maps.Animation.DROP
		});
		p.marker = marker;
		var _this = this;

		p.getInfoBoxHtml = Igloo.delegate(this,function( venue ){
			if(!venue.infoBoxHtml) {
				const template = this.getTemplate("map/window");
				const handlebar = Handlebars.compile(template);
				venue.infoBoxHtml = handlebar(venue);
			}
			return venue.infoBoxHtml;
		},p);

		p.setupInfoBox =  Igloo.delegate(this,function( venue ){

			if(!venue.infoBox){
				var ib = new InfoBox(infoBoxSetup);

				venue.openBox = Igloo.delegate(this,function(venue){

					for(var i in this.venues){
						var p = this.venues[i];
						if(p != venue && p.infoBoxStatus == "open"){
							p.closeBox();
						}
					}

					var w = this.$gmap.width();
					var h = this.$gmap.height();

					// By default, popup boxes are small and will wrap the address
					// We want to make them big enough so the address doesn't wrap, but limit to width of screen

					// Set the size to the width of the screen
					venue.$infoBox.css('width', w);

					// Find the wrapper for the text - this will be smaller than the infobox, if the text is smaller,
					// or will be about the size of the infobox if the text has to wrap
					const $markerDetails = venue.$infoBox.find(".map-marker__details");
					let width = $markerDetails.outerWidth(true) + 1; // plus 1 for rounding error
					let height = $markerDetails.outerHeight(true) + 1;
					venue.$infoBox.css("width", width);


					venue.$infoBox.find(".map-marker__reveal").css("height",0).animate({height:venue.infoBoxHeight},{easing:"easeOutCubic",duration:450});
					venue.infoBoxStatus = "open";

					//Is it in view, if not make it so
					var overlay = new google.maps.OverlayView();
					overlay.draw = function() {};
					overlay.setMap(map);

					const getPixelOffset = () => {
						var proj = overlay.getProjection();
						var pos = venue.marker.position
						var px = proj.fromLatLngToContainerPixel(pos);
						return px;
					}

					var px = getPixelOffset();
					this.getPixelOffset = getPixelOffset; // just for testing in the console

					var offset = [0,0];
					const popupPadding = w / 50;

					// Check for edges of map
					if(px.x < width / 2) {
						offset[0] = width / 2 - px.x + popupPadding;
					}
					if(px.x > w - width / 2) {
						offset[0] = (w - width / 2) - px.x - popupPadding;
					}

					if(px.y < height) {
						offset[1] = px.y - height - popupPadding;
					}

					if(px.y > h) {
						offset[1] = px.y - h + popupPadding ;
					}

					// check for edges of icon (accredited badge) - assume it's a rectangle!
					const $icon = $(".js-accredited-badge")
					const iconOffset = $icon[0].getBoundingClientRect();
					const mapOffset = this.$gmap[0].getBoundingClientRect();
					const iconScaling = 0.85; // there's some padding on the icon, so lets just take a fraction into account
					const iconOverlapX = iconOffset.x + iconOffset.width * iconScaling - mapOffset.x;
					const iconOverlapY = iconOffset.y + iconOffset.height * iconScaling - mapOffset.y;

					if(px.x - width / 2 < iconOverlapX && px.y - height < iconOverlapY ) { //
						offset[1] = px.y - (iconOverlapY + height) - popupPadding;
					}

					if(offset[0] || offset[1]) this.offsetCenter(offset);

				},venue);

				venue.killBox = Igloo.delegate(this, function(venue) {
					if (venue.infoBox) {
						venue.infoBox.close();
					}
				}, venue);

				venue.closeBox = Igloo.delegate(this,function(venue){
					venue.$infoBox.
						find(".map-marker__reveal").
						animate({
							height:0
						},{
							easing:"easeInOutCubic",
							duration:450,
							complete: Igloo.delegate(this, function(venue) {
								if (venue.infoBox) {
									venue.infoBox.close();
									venue.infoBox = false;
								}
							}, venue)
						});
					venue.infoBoxStatus = "closed";
				},venue);

				venue.toggleInfoBox = Igloo.delegate(this,function(venue){

					if(venue.infoBoxStatus == "open"){
						venue.closeBox();
					}else{
						venue.openBox();
					}
				},venue)

				ib.addListener("domready",Igloo.delegate(this,function(venue){
					venue.$infoBox = $("#map-marker-"+venue.index);

					nav.addToLinks(venue.$infoBox.find("a"));
					venue.infoBoxHeight = venue.$infoBox.find(".map-marker__inner").outerHeight();
					venue.infoBoxSetup = true;
					venue.$infoBox.find(".map-marker__icon").on("click",function(){
						venue.toggleInfoBox();
					});
					venue.$infoBox.find('.js-map-marker--close').on('click', function () {
						venue.closeBox();
					});
					venue.openBox();
				}, venue));

				ib.setContent(venue.getInfoBoxHtml());
				ib.open(map, venue.marker); //This doesn't actually show it - it's not revealed yet

				venue.infoBox = ib;
			}

			return venue.infoBox;
		}, p);

		marker.addListener('click', Igloo.delegate(this,function(venue) {
			// console.log("Setup info box", venue);

			var infoBox = venue.setupInfoBox(); //This will only happen once

			return;
			if (this.infoBoxVenue && this.infoBoxVenue != venue) {
				this.infoBoxVenue.closeBox();
			}


			if(venue.infoBoxSetup){
				venue.toggleInfoBox();
			}

			this.infoBoxVenue = venue;
		}, p));

		/*
		marker.addListener('mouseover', Igloo.delegate(this,function(venue) {
			this.setPano(venue);
		}, p));
		*/

		markers.push(marker);
	}

	var clusterStyle = {
		url: 			'/assets/images/icons/map_marker_cluster.svg',
		iconAnchor:		[20,20],
		height: 		45.4,
		width: 			120,
		textColor: 		'#FFE715', //'#DF0E95',
		textSize:		30,
	}
	var clusterStyles = [clusterStyle,clusterStyle,clusterStyle];

	var mcOptions = {
		gridSize: 60,
		styles: clusterStyles,
		//maxZoom: 11,
		minimumClusterSize: 3
	};

	if (this.markerCluster) {
		this.markerCluster.clearMarkers();
	}

	this.markerCluster = new MarkerClusterer(map, markers, mcOptions);
}
MapController.prototype.fitBounds = function(  ){

	//Centre the zoom - note that this could cause a knock on marker effect
	var props = this.filteredVenues ? this.filteredVenues : this.venues;
	var bounds = new google.maps.LatLngBounds();
	c = 0;
	for (var i = 0; i < props.length; i++) {
		if(props[i].marker){
			bounds.extend(props[i].marker.position);
			c++;
		}
	}

	if(c === 0){
		bounds.extend(new google.maps.LatLng({lat:54.53383250794428,lng: -4.691162109375}));
		bounds.extend(new google.maps.LatLng({lat:50.61113171332364,lng: 1.417236328125}));

		this.map.fitBounds(bounds);
	}else{
		this.map.fitBounds(bounds);
	}


}
MapController.prototype.setPano = function( venue, preload ){

	//Does it have a banner to load into? If not make it.
	var $banner = $(".banners");
	if(!$banner.size()){
		$(".body").before("<div id='streetview' class='banners banners-saved'></div>");
		var $banner = $(".banners");
	}
	this.$banner = $banner;






	if(venue.use_streetview){

		var centre = {lat: venue.streetview_lat * 1, lng: venue.streetview_long * 1};

		if(this.streetviewMap){
			//var $saved = $(".banners-saved");
			//$(".banners").last().remove();
			//$(".body").prepend($saved.css("visibility","visible"));


		}else {
			//https://www.google.co.uk/maps/place/David+Menzies+Associates/@,3a,60y,58.84h,83.81t/data=!3m6!1e1!3m4!1s5IOt8MFOJMUssO7y5q0b6A!2e0!7i13312!8i6656!4m2!3m1!1s0x4876052a99987055:0xccdbf8dec9b5efed!6m1!1e1



			var map = new google.maps.Map(document.getElementById('streetview'), {
				center: centre,
				zoom: 18,
				scrollwheel: false,
				addressControlOptions: {
					position: google.maps.ControlPosition.BOTTOM_CENTER
				}
			});
			var marker = new google.maps.Marker({
				position: {lat: venue.location_lat*1, lng: venue.location_long*1},
				map: map,
				icon: '/assets/images/icons/arrow-down-large-streetview.svg',
				title: 'Venue',
				animation: google.maps.Animation.BOUNCE,
			});

			this.streetviewMap = map;
			this.streetviewMarker = marker;
		}

		this.streetviewMarker.setAnimation(google.maps.Animation.BOUNCE);

		var panorama =  this.streetviewMap.getStreetView();
		panorama.setVisible(true);
		panorama.scrollwheel = false;

		var _this = this;
		var setPano = function(){
			if(_this.venue && _this.venue != venue){
				return false;
			}

			//Igloo.log("preload " + venue.name)

			if(venue.streetview_pano){
				if(panorama.getPano() !== venue.streetview_pano){
					panorama.setPano(venue.streetview_pano);
				}
			}else{
				panorama.setPosition(centre);
			}

			panorama.setPov(({
				heading: venue.streetview_heading*1,
				pitch: venue.streetview_pitch*1,
				zoom: venue.streetview_zoom*1
			}));
		}


		if(this.panoTimeouts){
			for(var i = 0; i < this.panoTimeouts.length; i++){
				clearTimeout(this.panoTimeouts[i]);
			}
		}else{
			this.panoTimeouts = [];
		}

		if(!preload){
			setPano();
			this.panoTimeouts.push(setTimeout(setPano,10));
			this.panoTimeouts.push(setTimeout(setPano,100));
		}
		this.panoTimeouts.push(setTimeout(setPano,500));



		this.panoTimeouts.push(setTimeout(setPano,1000));


		panorama.addListener('links_changed', function() {

		});

		this.panorama = panorama;

		this.streetviewMarker.setPosition({lat: venue.location_lat*1, lng: venue.location_long*1});

	}else{

	}
}
MapController.prototype.mapClick = function( e  ){
	if(this.infoBoxVenue) this.infoBoxVenue.closeBox();
}
MapController.prototype.zoomChanged = function( e  ){
	var zoom = this.map.getZoom();

	var size = 1;
	var cluster = 150;
	/*
	if(zoom > 13){
		size = 0.0000001;
	}else if(zoom > 11){
		cluster = 2;
		size = 60;
	}else if(zoom > 6){
		size = 60;
	}else if(zoom > 4){
		size = 60;
	}else if(zoom > 3){
		size = 60;
	}*/
	this.markerCluster.setGridSize(size);
	this.markerCluster.setMinClusterSize(cluster);

	if (this.infoBoxVenue) {
		this.infoBoxVenue.killBox();
	}

	var styles = this.getStyles(zoom);
	this.map.setOptions({styles: styles});

	this.savedZoom = zoom;

}
MapController.prototype.positionChanged = function( e  ){
	this.savedPosition = this.map.getCenter();
}
// Filter the venues based on the filters selected


MapController.prototype.offsetCenter = function(offset){

	// console.log(offset);


	if(window.block) return
// latlng is the apparent centre-point
// offsetx is the distance you want that point to move to the right, in pixels
// offsety is the distance you want that point to move upwards, in pixels
// offset can be negative
// offsetx and offsety are both optional


	var map = this.map;

	var scale = Math.pow(2, map.getZoom());
	var nw = new google.maps.LatLng(
		map.getBounds().getNorthEast().lat(),
		map.getBounds().getSouthWest().lng()
	);

	var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(map.getCenter());
	var pixelOffset = new google.maps.Point((offset[0]/scale) || 0,(offset[1]/scale) ||0);

	var worldCoordinateNewCenter = new google.maps.Point(
		worldCoordinateCenter.x - pixelOffset.x,
		worldCoordinateCenter.y + pixelOffset.y
	);

	var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

	// console.log("pan to ",newCenter);
	map.panTo(newCenter);

}

// MapController.prototype.onMediaChange = function() {
// 	this.isMobile = this.mql.matches;
// }